export class IndustryCodeDto {
  industryCode: string;
  majorCategory: string;
}
